<template>
  <div class="apartments">
    <div class="categoryTitleWrapper">
      <div class="gardeshgariTitle">دفاتر املاک</div>
    </div>
    <div class="amlakFilterWrapper" :class="{ showShadow: showShadow }">
      <div class="wrapperContainer">
        <div class="searchBarWrapper">
          <div class="apartmentClassSearchBar">
            <div class="topNav__searchbar_wrapper">
              <div class="filterbutton_wrapper">
                <button ref="filterButton" class="filterbutton">
                  <VsxIcon
                    iconName="SearchNormal1"
                    :size="23"
                    color="#000"
                    type="linear"
                    @click="search_branches"
                  />
                </button>
              </div>
              <input
                type="search"
                inputmode="search"
                enterkeyhint="search"
                v-model="fillter.title"
                class="searchbar_input"
                placeholder="جستجو..."
                @keyup.enter="search_branches"
              />
            </div>
          </div>
          <div class="resBackBtn" @click="historyBackHandler">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M73.4 297.4C60.9 309.9 60.9 330.2 73.4 342.7L233.4 502.7C245.9 515.2 266.2 515.2 278.7 502.7C291.2 490.2 291.2 469.9 278.7 457.4L173.3 352L544 352C561.7 352 576 337.7 576 320C576 302.3 561.7 288 544 288L173.3 288L278.7 182.6C291.2 170.1 291.2 149.8 278.7 137.3C266.2 124.8 245.9 124.8 233.4 137.3L73.4 297.3z"/></svg>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="amlakFilterList">
      <Swiper v-if="isLoading" :slides-per-view="'auto'">
        <SwiperSlide v-for="i in 16" :key="i">
          <Skeletor
            :key="i"
            class="ChildShowTextSearchBar"
            width="116"
            height="40"
            style="
              background: rgb(163, 219, 213);
              border-radius: 8px;
              margin-left: 9px;
            "
          />
        </SwiperSlide>
      </Swiper>
    </div> -->
    <!-- <div class="amlakFilterList">
      <Swiper
        v-if="data_list.length > 0 && !isLoading"
        :slides-per-view="'auto'"
      >
        <SwiperSlide>
          <div
            :class="['ChildShowTextSearchBar', { selected: fillter.cid == 0 }]"
            @click="selectSlide(0)"
          >
            <p title="همه">همه</p>
          </div>
        </SwiperSlide>
        <SwiperSlide v-for="(v, i) in category_list" :key="i">
          <div
            :class="[
              'ChildShowTextSearchBar',
              { selected: fillter.cid == v.id },
            ]"
            @click="selectSlide(v.id)"
          >
            <p :title="v.title">{{ v.title }}</p>
          </div>
        </SwiperSlide>
      </Swiper>
    </div> -->
    <!-- <div
      style="margin-top: 30px"
      v-if="data_list.length == 0 && isLoading"
      class="apartmentsListContainer"
    >
      <Skeletor
        v-for="(v, i) in 12"
        :key="i"
        class="ChildShowTabToUserCustomer sliderBottm"
        height="353"
        style="
          background: rgb(163, 219, 213);
          margin-bottom: 2rem;
          border-radius: 10px;
        "
      />
    </div> -->

    <div class="amlakRegionsWrapper">
      <div class="amlakReigons" v-if="isLoading">
        <div class="regionsThumb" v-for="i in 20" :key="i">
          <Skeletor
            class="regionThumbSkeletor"
            style="background: rgb(163, 219, 213)"
          />
        </div>
      </div>
      <div class="amlakReigons" v-if="!isLoading">
        <div
          class="regionsThumb"
          v-for="(v, i) in filtered_branch_list"
          @click="all_amklaks(v.id)"
          :key="i"
        >
          <div class="thumbPic">
            <img v-lazy :src="v.avatar" :alt="v.title" />
          </div>
          <div class="thumbContent">
            <p :title="v.title">{{ v.title }}</p>
          </div>
        </div>
      </div>
      <div class="loadeMoreLoader" v-if="loadmore_loading">
        <span class="custom-loader"></span>
      </div>
    </div>

    <div class="showMapBtn">
      <router-link to="/map-amlak" class="mapBtn">
        <div class="btnIcon">
          <VsxIcon iconName="Map1" :size="26" color="#fff" type="linear" />
        </div>
        <div class="btnTitle">نمایش دفاتر املاک روی نقشه</div>
      </router-link>
    </div>
    <!-- <div v-show="data_list.length > 0 && !isLoading">
      <div class="realStatesListContainer">
        <div
          class="realStateThumb"
          v-for="(v, i) in data_list"
          @click="amlak_profile(v.id)"
          :key="i"
        >
          <div class="thumbPic">
            <img :src="v.avatar" :alt="v.title" />
          </div>
          <div class="thumbContent">
            <div class="contentHeader">
              <div class="realStateTitle">
                {{ v.title }}
                <div v-if="v.tick_color" class="realStateTick">
                  <VsxIcon
                    iconName="Verify"
                    :size="18"
                    :color="v.tick_color"
                    type="bold"
                  />
                </div>
              </div>
              <div class="relStateLoc">
                <div class="locationIcon">
                  <i class="fa-solid fa-location-dot"></i>
                </div>
                <div class="locTitle">
                  {{ v.address }}
                </div>
              </div>
              <div class="realStatePhone">
                <div class="phoneIcon">
                  <i class="fa-solid fa-phone"></i>
                </div>
                <div class="phoneTitle">
                  {{ v.contact }}
                </div>
              </div>
            </div>
            <div class="contentFooter">
              <a :href="'tel:' + v.contact" class="footerCallBtn" @click.stop>
                <div class="callBtnIcon"><i class="fa-solid fa-phone"></i></div>
                <div class="callBtnTitle">تماس</div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="loadeMoreLoader" v-if="loadmore_loading">
        <span class="custom-loader"></span>
      </div>
      <div
        ref="loadMoreTrigger"
        class="trigger"
        v-show="data_list.length > 0"
      ></div>
    </div> -->

    <!-- <div class="showMapBtn">
      <router-link to="/map-amlak" class="mapBtn">
        <div class="btnIcon">
          <VsxIcon iconName="Map1" :size="26" color="#fff" type="linear" />
        </div>
        <div class="btnTitle">نمایش دفاتر املاک روی نقشه</div>
      </router-link>
    </div> -->

    <!-- <div v-show="data_list.length > 0 && !isLoading">
      <div class="apartmentsListContainer">
        <div
          @click="amlak_profile(v.id)"
          class="property-list"
          v-for="(v, i) in data_list"
          :key="i"
          style="cursor: pointer"
        >
          <a>
            <article class="property">
              <header class="property__ref-info">
                <div class="property__picture">
                  <img
                    class="SowImageToUser"
                    :src="v.avatar"
                    :alt="v.title"
                    :style="
                      v.has_avatar
                        ? ''
                        : 'object-fit: contain;background: #f5f5f5;'
                    "
                  />
                </div>
              </header>
              <section class="property__main-info">
                <div class="adviserTitle">
                  <h3 class="property__title">
                    {{ v.title }}
                  </h3>

                  <div
                    v-if="v.tick_color"
                    class="accommodation-pdp-specification"
                  >
                    <VsxIcon
                      iconName="Verify"
                      :size="20"
                      :color="v.tick_color"
                      type="linear"
                    />
                  </div>
                </div>
                <span class="property__location" v-if="v.address">
                  <VsxIcon
                    iconName="Location"
                    :size="24"
                    color="#0096c7 "
                    type="linear"
                  />
                  <span>
                    {{ v.address }}
                  </span>
                </span>
                <span class="property__location contactInfo" v-if="v.contact">
                  <VsxIcon
                    iconName="Call"
                    :size="24"
                    color="#0096c7 "
                    type="linear"
                  />
                  <span>
                    {{ v.contact }}
                  </span>
                </span>
                <spa class="property_contact" v-if="v.contact">
                  <a :href="'tel:' + v.contact" class="callBtn" @click.stop>
                    تماس
                    <VsxIcon
                      iconName="CallCalling"
                      :size="18"
                      color="#fff"
                      type="linear"
                    />
                  </a>
                </spa>
              </section>
            </article>
          </a>
        </div>
      </div>

      <div class="loadeMoreLoader" v-if="loadmore_loading">
        <span class="custom-loader"></span>
      </div>
      <div
        ref="loadMoreTrigger"
        class="trigger"
        v-show="data_list.length > 0"
      ></div>
    </div> -->

    <!-- <div
      v-if="data_list.length > 0 && loadmore && !isLoading"
      class="apartmentsLoadMoreDataButton"
    >
      <button
        class="loadButton"
        @click="load_data()"
        :disabled="loadmore_loading"
      >
        <span v-if="!loadmore_loading">نمایش بیشتر</span>
        <span v-else class="loader"></span>
      </button>
    </div> -->

    <div
      v-if="filtered_branch_list.length == 0 && !isLoading"
      class="justify-center align-center mt-4"
      style="text-align: center; height: 90%"
    >
      <img
        :src="publicPath + 'img/notfound.png'"
        alt="Alt text"
        width="320"
        height="280"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Skeletor } from "vue-skeletor";

export default {
  name: "amlakRegion",
  components: {
    Skeletor,
  },
  data() {
    return {
      publicPath: process.env.VUE_APP_PUBLIC_PATH,
      isLoading: false,
      branch_list: [],
      filtered_branch_list: [],
      fillter: {
        title: "",
      },
      showShadow: false,
    };
  },
  methods: {
    historyBackHandler() {
      history.back()
    },
    load_branch() {
      this.isLoading = true;
      axios.post(this.$store.getters.baseUrl + "/branch-list").then((r) => {
        this.branch_list = r.data.list;
        this.filtered_branch_list = r.data.list;
        this.isLoading = false;
        console.log("branch_list", this.branch_list);
      });
    },
    all_amklaks(cid) {
      this.$router.push({ path: "/amlak-list", query: { cid } });
    },
    search_branches() {
      const searchTerm = this.fillter.title.trim().toLowerCase();
      if (searchTerm === "") {
        this.filtered_branch_list = this.branch_list;
      } else {
        this.filtered_branch_list = this.branch_list.filter((branch) =>
          branch.name.toLowerCase().includes(searchTerm)
        );
      }
    },
    handleWindowScroll() {
      if (window.innerWidth < 700 && window.scrollY > 86) {
        this.showShadow = true;
      } else {
        this.showShadow = false;
      }
    },
  },
  async mounted() {
    this.load_branch();
    window.addEventListener("scroll", this.handleWindowScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleWindowScroll);
  },
};
</script>

<!-- <script setup>
import { ref, onMounted, onBeforeUnmount, onUnmounted } from "vue";
import store from "@/store";
import axios from "axios";
import { useRoute, useRouter } from "vue-router/dist/vue-router";
import { Skeletor } from "vue-skeletor";
// import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
// import Treeselect from "vue3-treeselect";
// import "vue3-treeselect/dist/vue3-treeselect.css";

const publicPath = ref(process.env.VUE_APP_PUBLIC_PATH);

const isLoading = ref(true);
const loadmore = ref(false);
const loadmore_loading = ref(false);
const router = useRouter();
const showItemNum = ref(11.6);

// const handleWindowScroll = () => {
//   const scrollTop = window.scrollY || document.documentElement.scrollTop;
//   const windowHeight = window.innerHeight;
//   const fullHeight = document.documentElement.scrollHeight;

//   // اگر کاربر تقریبا به انتهای صفحه رسیده باشه (مثلا ۱۰۰ پیکسل مونده باشه)
//   if (scrollTop + windowHeight + 100 >= fullHeight) {
//     // اگر لودموره فعاله و درحال لود نیستیم
//     if (loadmore.value && !loadmore_loading.value) {
//       load_data(); // دقت کن بدون "first" پارامتر
//     }
//   }
// };

onMounted(() => {
  load_data("first");
  load_branch();
  load_category();
  window.addEventListener("resize", updateCarouselConfig1);
  // window.addEventListener("scroll", handleWindowScroll);
  // const observer = new IntersectionObserver(
  //   ([entry]) => {
  //     if (entry.isIntersecting) {
  //       load_data();
  //     }
  //   },
  //   { threshold: 1.0 }
  // );
  // if (loadMoreTrigger.value) {
  //   observer.observe(loadMoreTrigger.value);
  // }
  setTimeout(() => {
    isLoading.value = false;
  }, 3500);
});

onUnmounted(() => {
  // window.removeEventListener("scroll", handleWindowScroll);
});

const category_list = ref([]);
const load_category = () => {
  axios.get(store.getters.baseUrl + "/branch-cat-list").then((r) => {
    category_list.value = r.data.list;
    console.log("category_list", category_list.value);
  });
};

// const selectSlide = (index) => {
//   fillter.value.cid = index;
//   load_data("first");
// };

const calculateItemsToShow = () => {
  const width = window.innerWidth;
  if (width > 1200) {
    return 11.6;
  } else if (width > 1000) {
    return 8.5;
  } else if (width > 600) {
    return 6.5;
  } else {
    return 6.5;
  }
};

const updateCarouselConfig1 = () => {
  const itemsToShow = calculateItemsToShow();
  showItemNum.value = itemsToShow;
};

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateCarouselConfig1);
});

const branch_list = ref([]);
const load_branch = () => {
  axios.post(store.getters.baseUrl + "/branch-list").then((r) => {
    branch_list.value = r.data.list;
    console.log("branch_list", branch_list.value);
  });
};

const loadMoreTrigger = ref(null);

const fillter = ref({
  title: "",
  cid: 0,
  page: 1,
  per_page: 12,
});
const route = useRoute();
const data_list = ref([]);
const load_data = (param) => {
  loadmore.value = true;
  loadmore_loading.value = true;
  fillter.value.page += 1;
  if (param == "first") {
    // isLoading.value = true;
    data_list.value = [];
    fillter.value.page = 1;
  }
  const cid = route.query.cid;
  if (cid) fillter.value.cid = cid;
  axios
    .post(store.getters.baseUrl + "/branch-list-all", fillter.value)
    .then((r) => {
      if (r.data.result == 0 && param == "first") {
        data_list.value = [];
        if (param != "first") {
          fillter.value.page -= 1;
        }
      } else {
        data_list.value = data_list.value.concat(r.data.list.list);
        console.log(r.data.list.list);
        if (r.data.list.list.total_page == fillter.value.page) {
          loadmore.value = false;
        }
      }
      // isLoading.value = false;
      loadmore_loading.value = false;
    });
};

// const amlak_profile = (bid) => {
//   // let main_cat=checkTab.value;
//   router.push({ path: "/profile-amlak", query: { bid } });
// };
const all_amklaks = (cid) => {
  router.push({ path: "/amlak-list", query: { cid } });
};
</script> -->

<style lang="scss" scoped>
.ShowTabToUserCustomer {
  width: 100% !important;
}

.loader {
  height: 40px;
  width: 40px;
  margin-top: 0 !important;
}

.classShowApartmentSow {
  position: relative;
}

.deleteIcon {
  position: absolute;
  top: 4%;
  left: 4%;
  width: 32px;
  aspect-ratio: 1;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  span {
    font-size: 1.25rem;
    color: #2dc635;
  }
}

.adviserosSearchBox {
  position: relative;
  flex-direction: row !important;

  .searchbar_input {
    width: 100%;
    padding: 0 4%;
  }

  .searchBtn {
  }
}

.adviserTitle {
  display: flex;
  align-items: center;

  .property__title {
    max-width: calc(100% - 25px);
  }
}

.property-list {
  a .property {
    .property__main-info {
      position: relative;
      min-height: 210px;
      .property__location {
        align-items: flex-start;
        svg {
          flex-shrink: 0;
        }

        &.contactInfo {
          span {
            font-size: 16px;
          }
        }

        span {
          flex: 1;
          line-height: 1.35rem;
          font-size: 14px;
        }
      }
    }
  }
}

.swiper {
  padding: 2px 1px;
  .swiper-slide {
    width: auto;
  }
}

.amlakFilterList {
  width: 100%;
  margin-top: 20px;
  margin-bottom: -9px;

  .ChildShowTextSearchBar {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    // width: 100%;
    padding: 0 18px;
    border-radius: 0.375rem;
    border: 1px solid rgb(209, 213, 219);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    color: #000;
    margin-left: 9px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.1s;
    background: #faf9fb;

    &.selected {
      border: 1px solid #0096c7;
      background: #0096c7;
      color: #fff;
    }
  }
}

.property_contact {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 12px;
  width: 100%;
  padding: 0 10px;

  .callBtn,
  .smsBtn {
    width: 100%;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #0096c7;
    color: #fff;
    font-size: 14px;
    border-radius: 5px;

    svg {
      margin-right: 4px;
    }
  }
}

.showMapBtn {
  position: fixed;
  bottom: 32px;
  left: 0;
  right: 0;
  z-index: 998;

  .mapBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 0 20px;
    height: 48px;
    background: #0096c7;
    color: #fff;
    cursor: pointer;
    font-size: 1rem;
    width: fit-content;
    margin: 0 auto;
    border-radius: 24px;
    border: 1px solid #fff;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
  }
}

.dark {
  .categoryTitleWrapper {
    .gardeshgariTitle {
      color: #fff !important;
    }
  }
}

.categoryTitleWrapper {
  width: 100%;
  text-align: center;
  margin-top: -16px;
  margin-bottom: 24px;

  .gardeshgariTitle {
    width: 100% !important;

    &::after,
    &::before {
      width: 90px !important;
    }
  }

  .categoryTitle {
    font-size: 1.25rem;
    line-height: 1.5rem;
    font-family: "iranyekanB", sans-serif;
    position: relative;
    padding-bottom: 15px;

    &::before {
      margin: auto;
      content: "";
      position: absolute;
      right: 0;
      left: 0;
      bottom: 2px;
      height: 1px;
      width: 95%;
      max-width: 255px;
      background-color: #333;
    }

    &::after {
      margin: auto;
      content: "";
      position: absolute;
      right: 0;
      left: 0;
      bottom: 0;
      height: 5px;
      width: 100px;
      background-color: #000000;
      border-radius: 5px;
    }
  }
}

@media (min-width: 700px) {
  .categoryTitleWrapper {
    display: none;
  }
}
</style>
